import { Avatar, Color, Font, Hyperlink, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Profile } from 'zens-store'
import { useTranslation } from 'react-i18next'
import { usePathname, useParams, Link } from 'zens-router'
import { titleForRole, urlForRoute } from '@dms/helper'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: Spacing.S,
    flexDirection: 'row',
    alignItems: 'center',
  },
  right: {
    marginLeft: Spacing.S,
  },
  email: {
    color: Color.metalGrey,
    fontFamily: Font.medium,
    fontSize: 14,
  },
  role: {
    fontSize: 14,
  },
  profile: {
    fontFamily: Font.medium,
    marginTop: Spacing.XS,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
  },
})

interface Props extends ViewProps {
  companyId: number
  profile: Profile
}
const AuthInfo = (props: Props) => {
  const { companyId, profile, style, ...otherProps } = props
  const { displayName, email } = profile
  const { t } = useTranslation()
  const pathname = usePathname()
  const [params] = useParams()
  const role = profile.roleForCompany(companyId)
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Avatar name={displayName} email={email} style={styles.avatar} />
      <View style={styles.right}>
        <Text level={5}>{displayName}</Text>
        <Text level={7} style={styles.email}>
          {email}
        </Text>
        <Text style={styles.role}>{titleForRole(role, t)}</Text>
        <Link href={{ pathname: `/profile`, params: { companyId, next: urlForRoute({ pathname, params }) } }} asChild>
          <Hyperlink textStyle={styles.profile} title={t('Profile and preferences')} testID="Auth.Profile" />
        </Link>
      </View>
    </View>
  )
}

export default AuthInfo
